module.exports = __webpack_public_path__ + "img/logo.a1078a11.png";